/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

export default class MenuItem extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';
}
